import React from "react";
import {styled} from "@reside/ui";

import {CellTextSmall} from "./index";
import {CopyToClipboardIconButton} from "./CopyToClipboardIconButton";

const AdmissionIdRow = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const AdmissionId = ({code}: {code: string}) => (
  <AdmissionIdRow>
    <CellTextSmall>ID: {code}</CellTextSmall>
    <CopyToClipboardIconButton
      value={code}
      testId={`copy-admission-id-${code}`}
    />
  </AdmissionIdRow>
);
